class KeywordSearchInput {
  
  private element: HTMLElement;
  private placeholderPC: string;
  private placeholderSP: string;
  private mediaQuery: MediaQueryList;
  private handleMediaQueryChange: () => void;

  constructor(element: HTMLElement) {
    this.element = element;
    this.placeholderPC = this.element.getAttribute("data-placeholder-pc") || "";
    this.placeholderSP = this.element.getAttribute("data-placeholder-sp") || "";

    this.handleMediaQueryChange = this.oneMediaQueryChange.bind(this);

    this.mediaQuery = window.matchMedia("(max-width: 840px)");
    this.mediaQuery.addEventListener("change", this.handleMediaQueryChange.bind(this));

    this.handleMediaQueryChange();
  }

  private oneMediaQueryChange() {
    if (this.mediaQuery.matches) {
      this.element.setAttribute("placeholder", this.placeholderSP);
    } else {
      this.element.setAttribute("placeholder", this.placeholderPC);
    }
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const keywordSearchInputElements = document.querySelectorAll(".js-keyword-search-input");
  keywordSearchInputElements.forEach((element) => {
    new KeywordSearchInput(element as HTMLElement);
  });
});
